import axios from "axios";
import { Fragment, useState } from "react";
import React from "react";
import {
  Dialog,
  Menu,
  Transition,
  Disclosure,
  Combobox,
} from "@headlessui/react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import mainLogo from "../mglogo.png";
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  MenuAlt2Icon,
  ShoppingBagIcon,
  UsersIcon,
  XIcon,
  ExclamationIcon,
  DocumentIcon,
  ArchiveIcon,
  ClipboardIcon,
  ShoppingCartIcon,
  TemplateIcon,
} from "@heroicons/react/outline";
import {
  CheckCircleIcon,
  SearchIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  ArrowSmDownIcon,
  ArrowSmUpIcon,
  ScaleIcon,
  ColorSwatchIcon,
  CogIcon,
} from "@heroicons/react/solid";
import ReactPaginate from "react-paginate";
import Customervehiclemodalcreate from "./Customervehiclemodalcreate";
import CustomervehiclemodalEdit from "./CustomervehiclemodalEdit";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const cards = [
  { name: "Total No of Customer", href: "#", icon: ScaleIcon, amount: "1" },
  // More items...
];

class CustomervehicleList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      redirect: false,
      deleteRedirect: false,
      logoutRedirect: false,
      search: "",
      cryptKey: "",
      deletealartmsg: false,
      deletecustomer: false,
      CustomervehicleList: [],
      opencustomervehicle: false,
      opencustomervehicleModalopenforedit: false,
      message:"Are you sure you want to delete the Vehicle Info?",
      links: [],
      totalnoof: "",
      from: "",
      to: "",
      perpage: "",
      editid: "",
      loader: "",
      overLay: "",
    };
  }

  setLoaderFunction = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "fixed inset-0 bg-black/30",
    });
  };
  closeLoaderFuncion = (e) => {
    this.setState({ loader: "" });
    this.setState({
      overLay: "",
    });
  };
  close = async (e) => {
    this.setState({ sidebarOpen: false });
  };
  open = async (e) => {
    console.log("open");
    this.setState({ sidebarOpen: true });
  };

  delete = async (e) => {
    this.setState({ deletealartmsg: true });
    this.setState({ cryptKey: e });
  };

  haldleDelete = async (e) => {
    if (this.state.deletealartmsg) {
      const token = localStorage.getItem("token");
      let id = this.state.cryptKey;
      //const id=this.setState({cryptKey:e});
      const resDelete = axios
        .get("public/api/vehicle/information/customer/delete/" + id, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((resDelete) => {
          if (resDelete.data.success) {
            this.setState({deleteRedirect:true});
            this.setState({ deletealartmsg: false });
          }else{
           
            this.setState({message:resDelete.data.message});
          }
        });
    }
  };

  handleInputModal = (e) => {
    if (e) {

      this.setState({opencustomervehicle:false});
      this.setState({deleteRedirect:true});
    }
  };

  componentDidMount() {
    this.setLoaderFunction();
    const token = localStorage.getItem("token");
    const res = axios
      .get("public/api/vehicle/information/customer/pagination", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        const vehicle_information_customers = res.data.vehicle_information_customers.data;
        let link = res.data.vehicle_information_customers.links;
        this.setState({ CustomervehicleList: vehicle_information_customers });
        this.setState({ loader: "" });
        this.setState({ links: link });
        this.setState({ perpage: res.data.vehicle_information_customers.per_page });
        this.setState({ from: res.data.vehicle_information_customers.from });
        this.setState({ to: res.data.vehicle_information_customers.to });
        this.setState({ totalnoofbranch: res.data.vehicle_information_customers.total });
      });
    this.closeLoaderFuncion();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.deleteRedirect == true) {
      this.setState({ deleteRedirect: false });
      const token = localStorage.getItem("token");
      const res = axios
      .get("public/api/vehicle/information/customer/pagination", {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        const vehicle_information_customers = res.data.vehicle_information_customers.data;
        let link = res.data.vehicle_information_customers.links;
        this.setState({ CustomervehicleList: vehicle_information_customers });
        this.setState({ loader: "" });
        this.setState({ links: link });
        this.setState({ perpage: res.data.vehicle_information_customers.per_page });
        this.setState({ from: res.data.vehicle_information_customers.from });
        this.setState({ to: res.data.vehicle_information_customers.to });
        this.setState({ totalnoofbranch: res.data.vehicle_information_customers.total });
      });
    }
  }

  Searchhandle = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  Search = (e) => {
    this.setLoaderFunction();
    this.state.branchList = [];
    const token = localStorage.getItem("token");
    const search = e.target.value;
    const res = axios
      .get("public/api/vehicle/information/customer/pagination?search_v="+search, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        const vehicle_information_customers = res.data.vehicle_information_customers.data;
        let link = res.data.vehicle_information_customers.links;
        this.setState({ CustomervehicleList: vehicle_information_customers });
        this.setState({ loader: "" });
        this.setState({ links: link });
        this.setState({ perpage: res.data.vehicle_information_customers.per_page });
        this.setState({ from: res.data.vehicle_information_customers.from });
        this.setState({ to: res.data.vehicle_information_customers.to });
        this.setState({ totalnoofbranch: res.data.vehicle_information_customers.total });
      });
    this.closeLoaderFuncion();
  };

  addvehicle = async (e) => {
    //  this.setState({ redirect: true });
    this.setState({ opencustomervehicle: true });
  };

  closebranch = async (e) => {
    this.setState({ opencustomervehicle: false });
  };

  Edit = async (e) => {
    this.setState({ editid: e });
    this.setState({ opencustomervehicleModalopenforedit: true });
  };
  closeeditbranch = async (e) => {
    this.setState({ opencustomervehicleModalopenforedit: false });
  };
  handleInputModalvehicleedit = async (e) => {
    if (e) {
     
      this.setState({deleteRedirect:true});
      this.setState({opencustomervehicleModalopenforedit:false});
    }
  };

  paginationFetch = async (e) => {
    if (e) {
      this.setLoaderFunction();
      const token = localStorage.getItem("token");
      const res = axios
        .get(e, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          // console.log(res.data.customers.data);
          const vehicle_information_customers = res.data.vehicle_information_customers.data;
          let link = res.data.vehicle_information_customers.links;
          this.setState({ CustomervehicleList: vehicle_information_customers });
          this.setState({ loader: "" });
          this.setState({ links: link });
          this.setState({ perpage: res.data.vehicle_information_customers.per_page });
          this.setState({ from: res.data.vehicle_information_customers.from });
          this.setState({ to: res.data.vehicle_information_customers.to });
          this.setState({ totalnoof: res.data.vehicle_information_customers.total });
        });
    }
    this.closeLoaderFuncion();
  };

  logout = async (e) => {
    e.preventDefault();
    var token = localStorage.getItem("token");

    const res = await axios.get("public/api/logout", {
      headers: {
        authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    //console.log(res);

    if (res.data.success) {
      localStorage.removeItem("token");

      //Start the timer
      this.setState({ logoutRedirect: true }); //After 1 second, set render to true
    }
  };

  render() {
    let token = localStorage.getItem("token");

    if (token == null) {
      return <Navigate to={"/Login"} />;
    }
    if (this.state.logoutRedirect) {
      return <Navigate to={"/Login"} />;
    }

    if (this.state.redirect) {
      //return <Navigate to={"/Branch"} />;
    }

    return (
      <>
        <div>
          <div className={this.state.overLay} aria-hidden="true" />

          {/* Replace with your content */}
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="sm:flex sm:items-center">
              <div className="sm:flex-auto">
                <h1 className="text-xl font-semibold text-gray-900">
                Vehicles{" "}
                </h1>
                <p className="mt-2 text-sm text-gray-700">
                  A list of all the Vehicle
                </p>
              </div>
              <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
                <button
                  onClick={this.addvehicle}
                  type="button"
                  className="inline-flex items-center justify-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto"
                >
                  Add Vehicle
                </button>
              </div>
            </div>
            <div className="mt-8 flex flex-col">
              <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                  <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                    <table
                      className={`min-w-full divide-y divide-gray-300 ${this.state.loader}`}
                    >
                      <thead className="bg-gray-50">
                        <tr>
                          <th
                            scope="col"
                            className="py-3 pl-4 pr-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 sm:pl-6"
                          >
                            Customer
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                          >
                            Vehicle info
                          </th>

                          <th
                            scope="col"
                            className="px-3 py-3 text-center text-xs font-medium uppercase tracking-wide text-gray-500"
                          >
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {this.state.CustomervehicleList.map((person) => (
                          <tr key={person.id}>
                            <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                              {person.customer.customer_display_name}
                            </td>

                            <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                              {person.vehicle_information}
                            </td>

                            <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-center text-sm font-medium sm:pr-6">
                              <span
                                onClick={() => this.Edit(person.id_crypt)}
                                className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 cursor-pointer"
                              >
                                Edit
                              </span>

                              <span
                                onClick={() => this.delete(person.id_crypt)}
                                className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-pink-100 text-pink-800 cursor-pointer"
                              >
                                Delete
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/*pagination*/}

          <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
            <div className="flex-1 flex justify-between sm:hidden"></div>
            <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
              <div>
                <p className="text-sm text-gray-700">
                  Showing <span className="font-medium">{this.state.from}</span>{" "}
                  to <span className="font-medium">{this.state.to}</span> of{" "}
                  <span className="font-medium">{this.state.totalnoof}</span>{" "}
                  results
                </p>
              </div>
              <div>
                <nav
                  className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px"
                  aria-label="Pagination"
                >
                  {/* Current: "z-10 bg-indigo-50 border-indigo-500 text-indigo-600", Default: "bg-white border-gray-300 text-gray-500 hover:bg-gray-50" */}

                  {this.state.links.map((person) => (
                    <a
                      onClick={() => this.paginationFetch(person.url)}
                      aria-current="page"
                      className="z-10 bg-indigo-50 border-indigo-500 text-indigo-600 relative inline-flex items-center px-4 py-2 border text-sm font-medium cursor-pointer"
                    >
                      <p>{person.label}</p>
                    </a>
                  ))}
                </nav>
              </div>
            </div>
          </div>

          {/*pagination/}

            {/* /End replace */}
        </div>

        {/*DeleteAlert */}
        <Transition.Root show={this.state.deletealartmsg} as={Fragment}>
          <Dialog
            as="div"
            className="fixed z-10 inset-0 overflow-y-auto"
            onClose={() => this.setState({ deletealartmsg: false,message:"Are you sure you want to delete the Vehicle Info?" })}
          >
            <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
              </Transition.Child>

              {/* This element is to trick the browser into centering the modal contents. */}
              <span
                className="hidden sm:inline-block sm:align-middle sm:h-screen"
                aria-hidden="true"
              >
                &#8203;
              </span>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                  <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                    <button
                      type="button"
                      className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                      onClick={() => this.setState({ deletealartmsg: false,message:"Are you sure you want to delete the Vehicle Info?" })}
                    >
                      <span className="sr-only">Close</span>
                      <XIcon className="h-6 w-6" aria-hidden="true" />
                    </button>
                  </div>
                  <div className="sm:flex sm:items-start">
                    <div className="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                      <ExclamationIcon
                        className="h-6 w-6 text-red-600"
                        aria-hidden="true"
                      />
                    </div>
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                      <Dialog.Title
                        as="h3"
                        className="text-lg leading-6 font-medium text-gray-900"
                      >
                        Delete Vehicle Info
                      </Dialog.Title>
                      <div className="mt-2">
                        <p className="text-sm text-gray-500">
                          {this.state.message}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                    <button
                      type="button"
                      className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                      onClick={this.haldleDelete}
                    >
                      Delete
                    </button>
                    <button
                      type="button"
                      className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                      onClick={() => this.setState({ deletealartmsg: false,message:"Are you sure you want to delete the Vehicle Info?" })}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Transition.Child>
            </div>
          </Dialog>
        </Transition.Root>
        {/*End DeleteAlert */}

        {/*add Cusotmer vehiclee */}
        <Transition.Root show={this.state.opencustomervehicle} as={Fragment}>
          <Dialog as="div" className="relative z-10" onClose={this.closebranch}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                    <div>
                      <Customervehiclemodalcreate
                        handleInputBranch={this.handleInputModal}
                        customerId={0}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        {/*add branch*/}

        {/** Modal customerVehicleEdit */}
        <Transition.Root
          show={this.state.opencustomervehicleModalopenforedit}
          as={Fragment}
        >
          <Dialog
            as="div"
            className="relative z-10"
            onClose={this.closeeditbranch}
          >
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end lg:items-center  justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8  md:max-w-screen-md lg:max-w-screen-lg sm:w-full sm:p-6">
                    <div>
                      <CustomervehiclemodalEdit
                        editId={this.state.editid}
                        handleInputbranch={this.handleInputModalvehicleedit}
                      />
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
        {/** Modal branchEdit*/}
      </>
    );
  }
}

export default CustomervehicleList;
